module.exports = __webpack_public_path__ + "assets/img/info_fill.d52b2ab0.svg";